import React from 'react';
import { Trans } from '@wix/cli-i18n';

export const ReadyState = () => {
  return <Trans i18nKey="dev_command.welcome" />;
};
